<template>
	<div>
		<!--编辑 -->
		<el-dialog @close="cancel()" :close-on-click-modal='false' :title="isEdit?'添加章节要点':'添加章节要点'"
			:visible.sync="dialog" width="80%">
			<div class="editor-content">
				<!-- 视频播放区域 -->
				<div class="video-container">
					<div class="video-player">
						<video ref="videoPlayer" :src="videoSrc" @timeupdate="updateProgress"
							@loadedmetadata="onVideoLoaded"></video>
						<div class="video-controls">
							<div class="play-btn" @click="togglePlay">
								<i :class="isPlaying ? 'el-icon-video-pause' : 'el-icon-video-play'"></i>
							</div>
							<div class="time-display">{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</div>
							<el-button icon="el-icon-plus" size="mini" @click="addChapterAtCurrentTime">添加章节</el-button>
						</div>
					</div>

					<div class="timeline-container">
						<div class="timeline" @click="seekVideo" ref="timeline">
							<div class="progress-bar" :style="{width: progressPercentage + '%'}"></div>
							<div v-for="(chapter, index) in points" :key="index" class="chapter-marker"
								:style="{left: calculateChapterPosition(chapter.part_time) + '%'}"
								:title="chapter.name">
							</div>

							<!-- 时间刻度 -->
							<div v-for="tick in timeTicks" :key="'timeTicks'+tick.position" class="time-tick"
								:class="{major: tick.major}" :style="{left: tick.position + '%'}"></div>
						</div>

						<!-- 时间刻度标签 -->
						<div class="time-scale">
							<span v-for="(label, index) in timeLabels" :key="index">{{ label }}</span>
						</div>
					</div>
				</div>

				<!-- 章节面板 -->
				<div class="chapter-panel">
					<div class="chapter-panel-header">
						<h3>章节要点</h3>
						<span>共{{ points.length }}章</span>
					</div>
					<h4 style="margin-bottom: 20px;">{{currentChapterName}}</h4>

					<div class="chapter-list">
						<div v-for="(chapter, index) in points" :key="index" class="chapter-item"
							:class="{active: currentChapterIndex === index}" @click="seekToChapter(chapter.part_time)">
							<div class="flex flex-b">
								<div class="chapter-time">{{ formatTime(chapter.part_time) }}</div>
								<div class="flex">
									<i class="el-icon-edit" @click.stop="editPoints(chapter,index)"></i>
									<i class="el-icon-delete" @click.stop="points.splice(index,1)"
										style="margin-left: 10px;"></i>
								</div>
							</div>
							<div class="chapter-name">{{ chapter.name }}</div>
							<div class="chapter-desc" v-if="chapter.desc">{{ chapter.desc }}</div>
						</div>

						<div v-if="points.length === 0" class="empty-text">
							<p>为视频内容添加章节，可以让视频结构更清晰</p>
						</div>
					</div>

					<el-button class="add-chapter-btn" type="primary" icon="el-icon-plus" @click="showAddChapterDialog">
						添加章节要点
					</el-button>
				</div>
			</div>

			<!-- <div class="save-actions">
				<el-button @click="cancel">取消</el-button>
				<el-button type="primary" @click="save">保存</el-button>
			</div> -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>


		<!-- 添加章节对话框 -->
		<el-dialog title="添加章节要点" :visible.sync="dialogVisible" width="30%">
			<el-form :model="newChapter" label-width="80px">
				<el-form-item label="时间点">
					<span>{{ formatTime(newChapter.part_time) }}</span>
				</el-form-item>
				<el-form-item label="要点名称" style="margin: 20px 0;">
					<el-input v-model="newChapter.name" placeholder="输入要点名称"></el-input>
				</el-form-item>
				<el-form-item label="要点简介">
					<el-input type="textarea" v-model="newChapter.desc" placeholder="输入要点简介" :rows="3"></el-input>
				</el-form-item>
			</el-form>
			<div class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="confirmAddChapter">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getCourseList,
		addUser,
		editUser,
		getUser
	} from '@/api/course'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			currentChapterIndexProp: {
				type: Number,
				default: 0,
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				videoSrc: '', // 替换为实际视频URL
				isPlaying: false,
				currentTime: 0,
				duration: 0,
				points: [],
				currentChapterIndex: -1,
				dialogVisible: false,
				newChapter: {
					part_time: 0,
					name: '',
					desc: ''
				},
				dialog: false,
				images: [],
				roleUuid: "",
				weightList: [],
				weight: '',
				isEdit: false,
				currentIndex: -1,
				currentChapterName: ''
			}
		},
		computed: {
			progressPercentage() {
				if (this.duration === 0) return 0;
				return (this.currentTime / this.duration) * 100;
			},
			timeTicks() {
				const ticks = [];
				const tickCount = 20; // 刻度数量

				for (let i = 0; i <= tickCount; i++) {
					const position = (i / tickCount) * 100;
					const major = i % 5 === 0; // 每5个刻度一个主要刻度

					ticks.push({
						position: position,
						major: major
					});
				}

				return ticks;
			},
			timeLabels() {
				const labels = [];
				const labelCount = 5; // 标签数量

				for (let i = 0; i <= labelCount; i++) {
					const time = (this.duration / labelCount) * i;
					labels.push(this.formatTime(time));
				}

				return labels;
			}
		},
		mounted() {},
		methods: {
			editPoints(item, index) {
				this.currentIndex = index
				this.newChapter = item
				this.dialogVisible = true
			},
			togglePlay() {
				if (this.isPlaying) {
					this.$refs.videoPlayer.pause();
				} else {
					this.$refs.videoPlayer.play();
				}
				this.isPlaying = !this.isPlaying;
			},
			updateProgress() {
				this.currentTime = this.$refs.videoPlayer.currentTime;

				// 高亮当前章节
				for (let i = this.points.length - 1; i >= 0; i--) {
					if (this.currentTime >= this.points[i].time) {
						this.currentChapterIndex = i;
						break;
					}
				}
			},
			onVideoLoaded() {
				this.duration = this.$refs.videoPlayer.duration;
			},
			seekVideo(event) {
				const timeline = this.$refs.timeline;
				const rect = timeline.getBoundingClientRect();
				const clickPosition = (event.clientX - rect.left) / rect.width;
				this.$refs.videoPlayer.currentTime = this.duration * clickPosition;
			},
			seekToChapter(time) {
				this.$refs.videoPlayer.currentTime = time;
				this.playVideo();
			},
			playVideo() {
				this.$refs.videoPlayer.play();
				this.isPlaying = true;
			},
			addChapterAtCurrentTime() {
				this.newChapter.part_time = this.currentTime;
				this.showAddChapterDialog();
			},
			showAddChapterDialog() {
				this.newChapter = {
					part_time: this.currentTime,
					name: '',
					desc: ''
				};
				this.dialogVisible = true;
			},
			confirmAddChapter() {
				if (this.newChapter.name.trim() === '') {
					this.$message.error('请输入章节名称');
					return;
				}

				let currentItem = this.points.find(item => {
					return item.part_time == this.newChapter.part_time
				})
				if (currentItem) {
					this.$message.error('已存在当前时间的要点');
					return;
				}

				if (this.currentIndex != -1) {
					this.points[this.currentIndex] = this.newChapter
				} else {
					this.points.push({
						...this.newChapter
					});
				}
				this.points.sort((a, b) => a.time - b.time);
				this.dialogVisible = false;
				this.$message.success('章节要点添加成功');
				this.currentIndex = -1
			},
			calculateChapterPosition(time) {
				if (this.duration === 0) return 0;
				return (time / this.duration) * 100;
			},
			formatTime(seconds) {
				const mins = Math.floor(seconds / 60);
				const secs = Math.floor(seconds % 60);
				return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
			},
			cancel() {
				// this.$confirm('确定取消编辑？所有未保存的更改将会丢失。', '提示', {
				// 	confirmButtonText: '确定',
				// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	this.currentIndex = -1
				// 	this.newChapter = []
				// 	this.$emit('input', false)
				// 	this.$message.info('已取消编辑');
				// });
				this.$emit('input', false)
			},
			save() {
				this.$message.success('保存成功');
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser() {
				this.$emit('confirm', this.points, this.currentChapterIndexProp)
			},
		},

		watch: {
			uuid(val) {
				this.currentChapterName = val.name
				if (val.points.length > 0) {
					this.points = val.points
				} else {
					this.points = []
				}
				this.videoSrc = val.file.url
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
	.video-chapter-editor {
		max-width: 1200px;
		margin: 0 auto;
		background: #fff;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.editor-header {
		padding: 20px;
		border-bottom: 1px solid #ebeef5;
	}

	.editor-header h2 {
		color: #303133;
		font-weight: 500;
	}

	.editor-content {
		display: flex;
		padding: 20px;
	}

	.video-container {
		flex: 7;
		margin-right: 20px;
	}

	.chapter-panel {
		flex: 3;
		border-left: 1px solid #ebeef5;
		padding-left: 20px;
	}

	.video-player {
		position: relative;
		background-color: #000;
		border-radius: 4px;
		overflow: hidden;
	}

	.video-player video {
		width: 100%;
		display: block;
	}

	.video-controls {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
		padding: 10px;
		color: white;
		display: flex;
		align-items: center;
	}

	.play-btn {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.2);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		margin-right: 15px;
	}

	.play-btn:hover {
		background: rgba(255, 255, 255, 0.3);
	}

	.time-display {
		color: #fff;
		font-size: 14px;
		margin-right: 15px;
	}

	.timeline-container {
		margin-top: 20px;
		position: relative;
	}

	.timeline {
		height: 40px;
		background: #f5f7fa;
		border-radius: 2px;
		position: relative;
		cursor: pointer;
	}

	.progress-bar {
		height: 4px;
		background: #409EFF;
		border-radius: 2px;
		position: absolute;
		top: 18px;
		left: 0;
		width: 0%;
	}

	.chapter-marker {
		position: absolute;
		top: 8px;
		width: 4px;
		height: 24px;
		background: #ff9900;
		transform: translateX(-2px);
		z-index: 10;
	}

	.time-scale {
		display: flex;
		justify-content: space-between;
		margin-top: 8px;
		font-size: 12px;
		color: #909399;
		padding: 0 5px;
	}

	.time-tick {
		position: absolute;
		top: 0;
		height: 4px;
		width: 1px;
		background: #dcdfe6;
	}

	.time-tick.major {
		height: 6px;
		background: #c0c4cc;
	}

	.time-tick-label {
		position: absolute;
		top: 8px;
		font-size: 10px;
		color: #909399;
		transform: translateX(-50%);
	}

	.chapter-panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
	}

	.chapter-list {
		height: 500px;
		overflow-y: scroll;
	}

	.chapter-item {
		padding: 12px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		margin-bottom: 10px;
		cursor: pointer;
	}

	.chapter-item.active {
		border-color: #409EFF;
		background-color: #ecf5ff;
	}

	.chapter-time {
		font-size: 12px;
		color: #909399;
		margin-bottom: 5px;
	}

	.chapter-name {
		font-weight: 500;
	}

	.chapter-desc {
		font-size: 12px;
		color: #606266;
		margin-top: 5px;
	}

	.add-chapter-btn {
		margin-top: 20px;
		width: 100%;
	}

	.empty-text {
		text-align: center;
		color: #909399;
		padding: 40px 0;
	}

	.el-dialog__body {
		padding: 20px;
	}

	.dialog-footer {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.save-actions {
		padding: 20px;
		border-top: 1px solid #ebeef5;
		display: flex;
		justify-content: flex-end;
	}

	::v-deep ::-webkit-scrollbar {
		display: none;
		/* 对于Chrome, Safari, Edge */
	}
</style>